@if (loading | async) {
    <div class="d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container-fluid p-3 mb-4 content" *ngIf="reservation">
        <div class="row justify-content-between align-items-center">
            <div class="w-fit">
                <app-back-button url="/reservations" component="Reservations"></app-back-button>
            </div>
            <div class="col-auto d-flex justify-content-end align-items-center">
                <button mat-raised-button class="action-button d-flex col-auto align-items-center me-2" (click)="onEditReservationClick()">
                    <mat-icon class="edit-button-icon">edit</mat-icon>
                    Edit Reservation
                </button>
                <button mat-raised-button *ngIf="reservation.status_id != 3" class="action-button warn-button d-flex col-auto align-items-center me-2" (click)="onCancelReservationClick()">
                    <mat-icon>delete</mat-icon>
                    Cancel Reservation
                </button>
                <button mat-raised-button *ngIf="reservation.status_id === 3" class="action-button d-flex col-auto align-items-center me-2" (click)="onUncancelReservationClick()">
                    <mat-icon>delete</mat-icon>
                    Uncancel Reservation
                </button>
                <button mat-raised-button *ngIf="displayNewClaimButton" class="action-button new-claim-button d-flex align-items-center" (click)="onStartClaimClick()">
                    {{ getNewClaimButtonText() }}
                </button>
            </div>
        </div>
        <div class="row align-items-center mt-3">
            <div class="col-xl-9 col-12">
                <div class="row">
                    <h1 class="header">
                        {{ reservation.property.property_name }}
                        <span class="text-muted property-name" *ngIf="reservation.guests[0]?.first_name || reservation.guests[0]?.last_name">
                            <span class="property-name-separator">|</span>
                            {{ reservation.guests[0].first_name }} {{ reservation.guests[0].last_name }}
                        </span>
                    </h1>
                </div>
                <div class="row mt-1">
                    <div class="d-flex">
                        <div class="col-12">
                            Safely Reservation ID: <span class="text-bold">{{ reservation.reservation_id }}</span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-12">
                            Reference ID: <span class="text-bold">{{ reservation.reservation_reference_id }}</span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-12">
                            Organization ID: <span class="text-bold" (click)="onViewReservationOrganizationClick()">
                                <a>{{ reservation.organization_id }}</a>
                            </span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-12">
                            Organization Name: <span class="text-bold" (click)="onViewReservationOrganizationClick()">
                                <a>{{ reservation.property.organization_name }}</a>
                            </span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="col-12">
                            Property ID: <span class="text-bold" (click)="onViewReservationPropertyClick()">
                                <a>{{ reservation.property.property_reference_id }}</a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-12 d-flex align-items-center date-display-container">
                <app-claim-detail-date-display class="arrival-date-display" [date]="reservation.arrival_date" detail="arrival"></app-claim-detail-date-display>
                <div class="date-display-line"></div>
                <app-claim-detail-date-display class="departure-date-display" [date]="reservation.departure_date" detail="departure"></app-claim-detail-date-display>
            </div>
        </div>
        <div class="row mt-3">
            <hr style="height: 1.5px" />
        </div>
        <div class="row mt-3">
            <div class="col-12 col-xl-7 reservation-details-container" [class.col-xl-7]="displayVerificationCard">
                <mat-card appearance="outlined" class="mat-elevation-z3 h-100">
                    <div *ngIf="loadingReservationDetails; else reservation_details_content"
                        class="reservation-detail-loading">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ng-template #reservation_details_content>
                        <div class="row">
                            <div [class.col-5]="!displayVerificationCard" [class.col-12]="displayVerificationCard">
                                <div class="row justify-content-between mb-3">
                                    <div class="col-auto">
                                        <mat-card-title>Reservation Details</mat-card-title>
                                    </div>
                                    <div class="col-auto" [hidden]="!displayVerificationCard">
                                        <app-pill 
                                            [text]="getFormattedReservationStatus(reservation)"
                                            [backgroundColor]="getReservationStatusPillColor(getReservationStatus(reservation))"
                                            [fontColor]="getColor(colorProp.StatusPillColor)">
                                        </app-pill>
                                    </div>
                                </div>
                                <div class="row detail-row">
                                    <div class="col-lg-3 col-12 text-muted detail-text">Total Guests</div>
                                    <div class="col-lg-9 col-12 detail-text">{{ reservation.number_of_guests }}</div>
                                </div>
                                <div class="row detail-row">
                                    <div class="col-lg-3 col-12 text-muted detail-text">Booking Date</div>
                                    <div class="col-lg-9 col-12 detail-text">{{ reservationDetailsBookingDate }}</div>
                                </div>
                                <div class="row detail-row">
                                    <div class="col-lg-3 col-12 text-muted detail-text">Arrival Date</div>
                                    <div class="col-lg-9 col-12 detail-text">{{ reservationDetailsArrivalDate }}</div>
                                </div>
                                <div class="row detail-row">
                                    <div class="col-lg-3 col-12 text-muted detail-text">Departure Date</div>
                                    <div class="col-lg-9 col-12 detail-text">{{ reservationDetailsDepartureDate }}</div>
                                </div>
                                <div class="row detail-row">
                                    <div class="col-lg-3 col-12 text-muted detail-text">Reservation Cost</div>
                                    <div class="col-lg-9 col-12 detail-text">{{ reservation.reservation_cost | currency:userContextProvider.currencyCode:'symbol':'1.2-2' }}</div>
                                </div>
                            </div>
                            <div *ngIf="reservation.guests.length > 0" [class.col-5]="!displayVerificationCard" [class.col-12]="displayVerificationCard">
                                <div class="row mb-3" [class.mt-3]="displayVerificationCard">
                                    <div class="col-12">
                                        <mat-card-title>Guest Details</mat-card-title>
                                    </div>
                                </div>
                                <div class="row detail-row">
                                    <div class="col-lg-3 col-12 text-muted detail-text">Name</div>
                                    <div class="col-lg-9 col-12 detail-text">
                                        <span [routerLink]="['/guests/detail', reservation.guests[0].guest_id]">
                                            <a>{{ guestDetails?.first_name }} {{guestDetails?.last_name }}</a>
                                        </span>
                                    </div>
                                </div>
                                <div class="row detail-row" *ngIf="guestDetails?.email">
                                    <div class="col-lg-3 col-12 text-muted detail-text">Email</div>
                                    <div class="col-lg-9 col-12 detail-text">{{ guestDetails?.email }}</div>
                                </div>
                                <div class="row detail-row" *ngIf="(guestDetails?.phone_number && userContextProvider.isNaUser())">
                                    <div class="col-lg-3 col-12 text-muted detail-text">Phone</div>
                                    <div class="col-lg-9 col-12 detail-text">{{ guestDetails?.phone_number }}</div>
                                </div>
                                <div class="row detail-row" *ngIf="(!noGuestBirthdayProvided && userContextProvider.isNaUser())">
                                    <div class="col-lg-3 col-12 text-muted detail-text">Birthdate</div>
                                    <div class="col-lg-9 col-12 detail-text">{{ dateFormat(guestDetails?.birth_date, userContextProvider.region) }}</div>
                                </div>
                                <div class="row detail-row" *ngIf="userContextProvider.isNaUser()">
                                    <div class="col-lg-3 col-12 text-muted detail-text">Address</div>
                                    <div class="col-lg-9 col-12 detail-text">{{ getFormattedAddress() }}</div>
                                </div>
                            </div>
                            <div [hidden]="displayVerificationCard" [class.col-2]="!displayVerificationCard"
                                [class.d-flex]="!displayVerificationCard"
                                [class.justify-content-end]="!displayVerificationCard">
                                <div class="col-auto">
                                    <app-pill [text]="getFormattedReservationStatus(reservation)"
                                        [backgroundColor]="getReservationStatusPillColor(getReservationStatus(reservation))"
                                        [fontColor]="getColor(colorProp.StatusPillColor)"
                                    >
                                    </app-pill>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </mat-card>
            </div>
            <div *ngIf="displayVerificationCard && reservation.guests.length > 0" class="col-12 col-xl-5 mobile-margin-top">
                <mat-card appearance="outlined" class="mat-elevation-z3 h-100">
                    <div *ngIf="loadingVerificationDetails;else reservation_guest_verification_content"
                        class="reservation-detail-loading">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ng-template #reservation_guest_verification_content>
                        <div class="row justify-content-between">
                            <div class="col-auto">
                                <mat-card-title>
                                    {{ userContextProvider.isNaUser() ? 'Screening' : 'Verification' }}: {{ reservation.guests[0].first_name }} {{ reservation.guests[0].last_name }}
                                </mat-card-title>
                            </div>
                            <div class="col-auto">
                                <app-pill 
                                    [text]="getVerificationStatusText(this.reservationGuestDetails)"
                                    [backgroundColor]="getVerificationStatusPillColor(reservationGuestDetails?.verification_result)"
                                    [fontColor]="getColor(colorProp.StatusPillColor)"
                                    *ngIf="getVerificationStatusText(this.reservationGuestDetails) != ''">
                                </app-pill>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <span class="d-flex justify-content-end align-items-center download-insurance-pdf"
                                (click)="onGuestVerificationPdfDownloadClick()">
                                <mat-icon class="download-insurance-pdf-icon">publish</mat-icon>
                                Download Guest {{ userContextProvider.isNaUser() ? 'Screening' : 'Verification' }} PDF
                            </span>
                        </div>
                        <div class="row mt-2" *ngIf="reservation.guests[0]?.guest_id">
                            <a class="d-flex justify-content-end align-items-center go-to-guest-link" [routerLink]="['/guests/detail', reservation.guests[0].guest_id]">
                                <mat-icon class="go-to-guest-icon">people</mat-icon>
                                Go to Guest details
                            </a>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-5">
                                <app-reservation-detail-verification-status-row statusText="Identity {{ userContextProvider.isNaUser() ? 'Check' : 'Verification' }}"
                                    [verificationResult]="identityVerificationResult">
                                </app-reservation-detail-verification-status-row>
                            </div>
                            <div class="col-12 mt-5">
                                <app-reservation-detail-verification-status-row statusText="Global Sanction & Watch Lists"
                                    [verificationResult]="watchListVerificationResult">
                                </app-reservation-detail-verification-status-row>
                            </div>
                            <div class="col-12 mt-5" *ngIf="userContextProvider.isNaUser()">
                                <app-reservation-detail-verification-status-row statusText="US Criminal History"
                                    [verificationResult]="criminalVerificationResult">
                                </app-reservation-detail-verification-status-row>
                            </div>
                            <div class="col-12 mt-5" *ngIf="userContextProvider.isNaUser()">
                                <app-reservation-detail-verification-status-row statusText="US Sex Offender List"
                                    [verificationResult]="sexOffenderVerificationResult">
                                </app-reservation-detail-verification-status-row>
                            </div>
                            <div class="col-12 mt-5" *ngIf="userContextProvider.isNaUser()">
                                <app-reservation-detail-verification-status-row statusText="Safely's Prior Rental Database"
                                    [verificationResult]="priorRentalGuestVerificationResult">
                                </app-reservation-detail-verification-status-row>
                            </div>
                            <div class="col-12 mt-5">
                                <div class="row detail-row">
                                    <div class="col-lg-9 col-9 detail-text">Verification Cost</div>
                                    <div class="col-lg-3 col-3 detail-text">{{ reservation.verification_cost | currency:userContextProvider.currencyCode:'symbol':'1.2-2' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </mat-card>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12 col-xl-7">
                <mat-card appearance="outlined" class="mat-elevation-z3 h-100">
                    <div *ngIf="loadingReservationDetails;else reservation_insurance_detail_content"
                        class="reservation-detail-loading">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ng-template #reservation_insurance_detail_content>
                        <div class="row">
                            <div class="col-12">
                                <mat-card-title>Insurance Coverage</mat-card-title>
                            </div>
                        </div>
                        <div class="row detail-row mt-3">
                            <div class="col-lg-6 col-12 detail-text" style="font-size:1.4em;">Insurance Policy</div>
                            <div class="col-lg-6 col-12 detail-text">
                                <span (click)="onViewPolicyDetailClick()">
                                    <a>{{ insurancePolicy?.policy?.name }}</a>
                                </span>
                            </div>
                        </div>
                        <div class="row my-2">
                            <h2 style="font-size:1.4em;">Insurance Policy Limits</h2>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-6 col-12 text-muted detail-text">Contents Coverage</div>
                            <div class="col-lg-6 col-12 detail-text">
                                {{ insurancePolicy?.policy?.damage_coverage | currency:userContextProvider.currencyCode:'symbol':'1.2-2' }}
                            </div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-6 col-12 text-muted detail-text">Homeowner Liability Coverage</div>
                            <div class="col-lg-6 col-12 detail-text">
                                {{ insurancePolicy?.policy?.liability_coverage | currency:userContextProvider.currencyCode:'symbol':'1.2-2' }}
                            </div>
                        </div>
                        <div class="row detail-row mt-2">
                            <div class="col-lg-6 col-12 text-muted detail-text">Dwelling Coverage</div>
                            <div class="col-lg-6 col-12 detail-text">
                                {{ insurancePolicy?.policy?.dwelling_coverage | currency:userContextProvider.currencyCode:'symbol':'1.2-2' }}
                            </div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-6 col-12 text-muted detail-text">Deductible</div>
                            <div class="col-lg-6 col-12 detail-text">
                                {{ insurancePolicy?.deductible | currency:userContextProvider.currencyCode:'symbol':'1.2-2' }}
                            </div>
                        </div>
                        <div class="row detail-row">
                            <div class="col-lg-6 col-12 detail-text">Insurance Cost</div>
                            <div class="col-lg-6 col-12 detail-text">{{ insurancePolicy?.insurance_cost | currency:userContextProvider.currencyCode:'symbol':'1.2-2' }}
                            </div>
                        </div>
                    </ng-template>
                </mat-card>
            </div>
            <div class="col-12 col-xl-5 mobile-margin-top">
                <mat-card appearance="outlined" class="mat-elevation-z3 h-100">
                    <div *ngIf="loadingClaimHistory;else reservation_claim_history" class="reservation-detail-loading">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ng-template #reservation_claim_history>
                        <div class="row mb-3">
                            <div class="col-12">
                                <mat-card-title>Claims</mat-card-title>
                            </div>
                        </div>
                        <div class="row">
                            <div class="row detail-row mt-2 mb-5">
                                <div class="col-lg-4 col-12 detail-text" style="font-size:1.2em;">
                                    Claim Token
                                </div>
                                <div class="col-lg-8 col-12 detail-text" style="margin-top:5px;">
                                    {{ reservation.claim_token }}
                                </div>
                            </div>
                            <div class="row detail-row mb-5">
                                <div class="col-lg-4 col-12 detail-text" style="font-size:1.2em;">
                                    Claim By Token Link
                                </div>
                                <div class="col-lg-8 col-12 detail-text">
                                    <a (click)="goToClaimTokenLink()" style="cursor:pointer;">https://claim.safely.com/?claim_token={{reservation.claim_token}}</a>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-between my-2">
                            <div class="col-auto">
                                <mat-card-title>Claim History</mat-card-title>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div *ngIf="claimHistoryCount<=0; else claimHistoryTable">
                                <div class="row justify-content-start">
                                    <div class="col-9 d-flex">
                                        <span class="pt-2">
                                            No Claims Exist for Reservation
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <ng-template #claimHistoryTable>
                                <table mat-table [dataSource]="claimHistoryDataSource">
                                    <ng-container matColumnDef="claimId">
                                        <th mat-header-cell *matHeaderCellDef>Claim ID</th>
                                        <td mat-cell *matCellDef="let element">{{ element.claimId }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="dateSubmitted">
                                        <th mat-header-cell *matHeaderCellDef>Date Submitted</th>
                                        <td mat-cell *matCellDef="let element">{{ dateFormat(element.dateSubmitted, userContextProvider.region) }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="status">
                                        <th mat-header-cell *matHeaderCellDef>Status</th>
                                        <td mat-cell *matCellDef="let element">
                                            <app-pill [text]="element.status" [backgroundColor]="element.backgroundColor">
                                            </app-pill>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="claimDetails">
                                        <th mat-header-cell *matHeaderCellDef>Claim Details</th>
                                        <td mat-cell *matCellDef="let element">
                                            <div class="d-flex flex-row align-content-center">
                                                <span class="detail-cell">Details <mat-icon class="pageview-icon">pageview</mat-icon></span>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="claimHistoryColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: claimHistoryColumns"
                                        (click)="onClaimClick(row)">
                                    </tr>
                                </table>
                            </ng-template>
                        </div>
                    </ng-template>
                </mat-card>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <mat-card appearance="outlined" class="mat-elevation-z3 h-100">
                    <div *ngIf="loadingReservationDetails;else reservation_property_details"
                        class="reservation-detail-loading">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ng-template #reservation_property_details>
                        <div class="row mb-3">
                            <div class="col-12">
                                <mat-card-title>Property Details</mat-card-title>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="row detail-row">
                                    <span class="detail-text">
                                        <span class="text-muted">Safely Prop. ID: </span>
                                        <span (click)="onViewReservationPropertyClick()">
                                            <a>{{ reservation.property.property_id }}</a>
                                        </span>
                                    </span>
                                </div>
                                <div class="row detail-row">
                                    <span class="detail-text"><span class="text-muted">Property ID: </span>
                                        {{ reservation.property.property_reference_id }}
                                    </span>
                                </div>
                                <div class="row detail-row">
                                    <span class="detail-text"><span class="text-muted">Property Name: </span>
                                    <span (click)="onViewReservationPropertyClick()">
                                        <a>{{ reservation.property.property_name }}</a>
                                    </span>
                                    </span>
                                </div>
                                <div class="row detail-row">
                                    <span class="detail-text"><span class="text-muted">Property Address: </span>
                                        {{ formattedPropertyAddress$ | async }}
                                    </span>
                                </div>
                                <div class="row detail-row">
                                    <span class="detail-text"><span class="text-muted">Organization: </span>
                                        {{ reservation.property.organization_name }}
                                    </span>
                                </div>
                                <div class="row detail-row">
                                    <span class="detail-text"><span class="text-muted">Home Owner: </span>
                                        {{ reservation.property.property_owner_name }}
                                    </span>
                                </div>
                                <div class="row detail-row" *ngIf="propertyType">
                                    <span class="detail-text"><span class="text-muted">Type: </span>
                                        {{ propertyType | titlecase }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-xl-6 col-12">
                                <div class="row detail-row">
                                    <span class="detail-text d-flex align-items-center">
                                        <span class="text-muted d-flex property-info-icon">
                                            <mat-icon>person</mat-icon>
                                        </span>
                                        {{ reservation.property.accommodates || 0 }} guests
                                    </span>
                                </div>
                                <div class="row detail-row">
                                    <span class="detail-text d-flex align-items-center">
                                        <span class="text-muted d-flex property-info-icon">
                                            <mat-icon>airline_seat_individual_suite</mat-icon>
                                        </span>
                                        {{ reservation.property.bedrooms || 0 }} bedrooms
                                    </span>
                                </div>
                                <div class="row detail-row">
                                    <span class="detail-text d-flex align-items-center">
                                        <span class="text-muted d-flex property-info-icon">
                                            <mat-icon>wc</mat-icon>
                                        </span>
                                        {{ reservation.property.bathrooms || 0 }} bathrooms
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row flex-row property-photos-container mt-3" *ngIf="propertyPhotos && propertyPhotos.length > 0">
                            <div class="col-12 d-flex p-0">
                                <img *ngFor="let photo of propertyPhotos" [src]="photo" class="rounded property-photo"
                                    (click)="modalPropertyPhoto = photo; $event.stopPropagation()">
                            </div>
                        </div>
                    </ng-template>
                </mat-card>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <mat-card appearance="outlined" class="mat-elevation-z3 h-100">
                    <div *ngIf="loadingReservationHistory;else reservation_history_content"
                        class="reservation-detail-loading">
                        <mat-spinner></mat-spinner>
                    </div>
                    <ng-template #reservation_history_content>
                        <div class="row mb-3">
                            <div class="col-12">
                                <mat-card-title>Reservation History</mat-card-title>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <table mat-table [dataSource]="reservationHistoryDataSource">
                                <ng-container matColumnDef="timestamp">
                                    <th mat-header-cell *matHeaderCellDef>Date/Time</th>
                                    <td mat-cell *matCellDef="let element">{{ dateFormat(element.updatedDate, userContextProvider.region) }} - {{ element.updatedTime }}</td>
                                </ng-container>
                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef>Status</th>
                                    <td mat-cell *matCellDef="let element">{{ element.status }}</td>
                                </ng-container>
                                <ng-container matColumnDef="arrivalDate">
                                    <th mat-header-cell *matHeaderCellDef>Arrival Date</th>
                                    <td mat-cell *matCellDef="let element">{{ dateFormat(element.arrivalDate, userContextProvider.region) }}</td>
                                </ng-container>
                                <ng-container matColumnDef="departureDate">
                                    <th mat-header-cell *matHeaderCellDef>Departure Date</th>
                                    <td mat-cell *matCellDef="let element">{{ dateFormat(element.departureDate, userContextProvider.region) }}</td>
                                </ng-container>
                                <ng-container matColumnDef="numberOfNights">
                                    <th mat-header-cell *matHeaderCellDef>Total Nights</th>
                                    <td mat-cell *matCellDef="let element">{{ element.numberOfNights }}</td>
                                </ng-container>
                                <ng-container matColumnDef="insuranceCost">
                                    <th mat-header-cell *matHeaderCellDef>Insurance Cost</th>
                                    <td mat-cell *matCellDef="let element">{{ element.insuranceCost | currency:userContextProvider.currencyCode:'$':'1.2-2' }}</td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="reservationHistoryColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: reservationHistoryColumns"></tr>
                            </table>
                        </div>
                    </ng-template>
                </mat-card>
            </div>
        </div>
    </div>
    <div *ngIf="modalPropertyPhoto" class="photo-modal">
        <img [src]="modalPropertyPhoto" class="photo-modal-content" #photoModal>
    </div>
}